/* MARQUE v52: full-size product previews on touch screens.
   The native card link, Shopify variant forms, and selected color stay intact. */
(()=> {
  'use strict';
  if(window.marqueV52Ready) return;
  window.marqueV52Ready=true;
  const cardsSelector='.marque-card[data-marque-card-view]';
  function updateCard(card) {
    if(!(card instanceof HTMLElement)) return;
    const tabs=card.querySelector('[data-marque-card-tabs]');
    if(!(tabs instanceof HTMLElement)) return;
    const pair=Array.from(card.querySelectorAll('.marque-card__pair'))
      .find(node=>!node.hidden);
    const canShowBack=pair?.dataset.hasBack==='true' &&
      !!pair.querySelector('.marque-card__view--back');
    tabs.hidden=!canShowBack;
    tabs.dataset.marqueReady='true';
    const view=canShowBack && card.dataset.marqueCardView==='back' ? 'back':'front';
    card.dataset.marqueCardView=view;
    tabs.querySelectorAll('[data-marque-card-side]').forEach(button=>{
      const active=button.getAttribute('data-marque-card-side')===view;
      button.setAttribute('aria-pressed',String(active));
      button.tabIndex=0;
    });
  }
  function init(container=document) {
    container.querySelectorAll?.(cardsSelector).forEach(updateCard);
  }
  document.addEventListener('click', event=>{
    if(!(event.target instanceof Element))return;
    const sideButton=event.target.closest('[data-marque-card-side]');
    if(sideButton){
      const card=sideButton.closest(cardsSelector);
      if(!card)return;
      const chosen=sideButton.getAttribute('data-marque-card-side');
      if(chosen!=='front'&&chosen!=='back')return;
      event.preventDefault();
      event.stopPropagation();
      card.dataset.marqueCardView=chosen;
      updateCard(card);
      return;
    }
    if(event.target.closest('.marque-card__swatch[data-colour]')){
      const card=event.target.closest(cardsSelector);
      if(card)requestAnimationFrame(()=>{card.dataset.marqueCardView='front';updateCard(card);});
    }
  });
  document.addEventListener('shopify:section:load',event=>init(event.target));
  window.addEventListener('pageshow',()=>init());
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});
  else init();
  let frame=0;
  const observer=new MutationObserver(records=>{
    if(!records.some(r=>Array.from(r.addedNodes).some(n=>n.nodeType===1 &&
      (n.matches?.(cardsSelector)||n.querySelector?.(cardsSelector)))))return;
    if(frame)return;
    frame=requestAnimationFrame(()=>{frame=0;init();});
  });
  observer.observe(document.body,{childList:true,subtree:true});
})();